import pageData from '../../pageData'

const [birthYear, birthMonth, birthDay] = pageData().birthDate.split('-').map(Number)

export default class AboutRender {

    birthDate = new Date(birthYear, birthMonth - 1, birthDay)

    domElements = {
        age: document.getElementById('about-age'),
    }

    constructor() {
        this.renderAge()
    }

    renderAge() {
        if (!this.domElements.age) return

        const today = new Date()
        let age = today.getFullYear() - this.birthDate.getFullYear()
        const birthdayPassed = today.getMonth() > this.birthDate.getMonth()
            || (today.getMonth() == this.birthDate.getMonth() && today.getDate() >= this.birthDate.getDate())
        if (!birthdayPassed) age--

        this.domElements.age.textContent = age
    }
}
